import { safeAxios } from '@/services/safeAxios';
import { RunCostResponse } from '../api.shared.types';
import { RecipeRunCostRequest } from './recipe-runs.api.types';

export const getRecipeRunCostApi = async ({ costUrl, body }: RecipeRunCostRequest) => {
  const res = await safeAxios.post<RunCostResponse>(costUrl, body, {
    'axios-retry': { retries: 0 },
  });
  return res.data;
};
